import { tv } from 'tailwind-variants';

const button = tv({
  slots: {
    base: 'flex items-center justify-center cursor-pointer outline-none border-solid border border-transparent relative group hover:opacity-90 active:opacity-90 focus:opacity-90 transition-colors duration-200 ease-in-out',
    leftIconStroke: '',
    leftIconFill: '',
    rightIconStroke: '',
    rightIconFill: '',
    text: '',
    spinner: 'opacity-90 [&>path:nth-child(odd)]:opacity-50'
  },
  variants: {
    type: {
      button: {
        base: ''
      }
    },
    buttonType: {
      brand: {
        base: 'text-white bg-brand hover:opacity-90',
        spinner: 'icon-fill-color-text-action-inverse',
        leftIconStroke:
          'icon-stroke-color-text-action-inverse group-hover:icon-stroke-color-text-action-inverse group-active:icon-stroke-color-text-action-inverse group-disabled:icon-stroke-color-text-inactive',
        leftIconFill:
          'icon-fill-color-text-action-inverse group-hover:icon-fill-color-text-action-inverse group-active:icon-fill-color-text-action-inverse group-disabled:icon-fill-color-text-inactive',
        rightIconStroke:
          'icon-stroke-color-text-action-inverse group-hover:icon-stroke-color-text-action-inverse group-active:icon-stroke-color-text-action-inverse group-disabled:icon-stroke-color-text-inactive',
        rightIconFill:
          'icon-fill-color-text-action-inverse group-hover:icon-fill-color-text-action-inverse group-active:icon-fill-color-text-action-inverse group-disabled:icon-fill-color-text-inactive'
      },
      danger: {
        base: 'text-white bg-red-700 hover:bg-button-active-danger active:bg-button-active-danger',
        spinner: 'icon-fill-color-text-action-inverse',
        leftIconStroke:
          'icon-stroke-color-text-action-inverse group-hover:icon-stroke-color-text-action-inverse group-active:icon-stroke-color-text-action-inverse group-disabled:icon-stroke-color-text-inactive',
        leftIconFill:
          'icon-fill-color-text-action-inverse group-hover:icon-fill-color-text-action-inverse group-active:icon-fill-color-text-action-inverse group-disabled:icon-fill-color-text-inactive',
        rightIconStroke:
          'icon-stroke-color-text-action-inverse group-hover:icon-stroke-color-text-action-inverse group-active:icon-stroke-color-text-action-inverse group-disabled:icon-stroke-color-text-inactive',
        rightIconFill:
          'icon-fill-color-text-action-inverse group-hover:icon-fill-color-text-action-inverse group-active:icon-fill-color-text-action-inverse group-disabled:icon-fill-color-text-inactive'
      },
      cta: {
        base: 'text-action-inverse bg-button-default-cta hover:bg-button-active-cta active:bg-button-active-cta',
        spinner: 'icon-fill-color-text-action-inverse',
        leftIconStroke:
          'icon-stroke-color-text-action-inverse group-hover:icon-stroke-color-text-action-inverse group-active:icon-stroke-color-text-action-inverse group-disabled:icon-stroke-color-text-inactive',
        leftIconFill:
          'icon-fill-color-text-action-inverse group-hover:icon-fill-color-text-action-inverse group-active:icon-fill-color-text-action-inverse group-disabled:icon-fill-color-text-inactive',
        rightIconStroke:
          'icon-stroke-color-text-action-inverse group-hover:icon-stroke-color-text-action-inverse group-active:icon-stroke-color-text-action-inverse group-disabled:icon-stroke-color-text-inactive',
        rightIconFill:
          'icon-fill-color-text-action-inverse group-hover:icon-fill-color-text-action-inverse group-active:icon-fill-color-text-action-inverse group-disabled:icon-fill-color-text-inactive'
      },
      basic: {
        base: 'text-action bg-button-default-basic hover:bg-button-active-basic active:bg-button-active-basic',
        spinner: 'icon-fill-color-text-action',
        leftIconStroke:
          'icon-stroke-color-text-action icon-stroke-color-text-action group-hover:icon-stroke-color-text-subtle group-active:icon-stroke-color-text-action group-disabled:icon-stroke-color-text-inactive',
        leftIconFill:
          'icon-fill-color-text-action group-hover:icon-fill-color-text-subtle group-active:icon-fill-color-text-action group-disabled:icon-fill-color-text-inactive',
        rightIconStroke:
          'icon-stroke-color-text-action icon-stroke-color-text-action group-hover:icon-stroke-color-text-subtle group-active:icon-stroke-color-text-action group-disabled:icon-stroke-color-text-inactive',
        rightIconFill:
          'icon-fill-color-text-action group-hover:icon-fill-color-text-subtle group-active:icon-fill-color-text-action group-disabled:icon-fill-color-text-inactive'
      }
    },
    radius: {
      xs: 'rounded-xs',
      sm: 'rounded-sm',
      md: 'rounded-md',
      lg: 'rounded-lg',
      xl: 'rounded-xl',
      '2xl': 'rounded-2xl',
      full: 'rounded-full'
    },
    spaceX: {
      xs: 'px-button-xs',
      sm: 'px-button-sm',
      md: 'px-button-md',
      lg: 'px-button-lg',
      xl: 'px-button-xl',
      '2xl': 'px-button-2xl',
      '3xl': 'px-button-3xl'
    },
    spaceY: {
      xs: 'py-button-xs',
      sm: 'py-button-sm',
      md: 'py-button-md',
      lg: 'py-button-lg',
      xl: 'py-button-xl',
      '2xl': 'py-button-2xl',
      '3xl': 'py-button-3xl'
    },
    gap: {
      xs: 'gap-button-xs',
      sm: 'gap-button-sm',
      md: 'gap-button-md',
      lg: 'gap-button-lg',
      xl: 'gap-button-xl',
      '2xl': 'gap-button-2xl',
      '3xl': 'gap-button-3xl'
    },
    size: {
      sm: {
        base: 'p-button-lg rounded-sm gap-button-lg',
        text: 'text-LabelSemiboldSm'
      },
      md: {
        base: 'p-button-2xl rounded-md gap-button-2xl',
        text: 'text-LabelSemiboldMd'
      },
      lg: {
        base: 'p-button-3xl rounded-md gap-button-3xl',
        text: 'text-LabelSemiboldLg'
      }
    },
    hasIcon: {
      true: 'justify-between'
    },
    isFullWidth: {
      true: 'w-full'
    },
    loading: {
      true: 'justify-center'
    },
    disabled: {
      true: ''
    },
    leftIconColorAttr: {
      fill: '',
      stroke: ''
    },
    rightIconColorAttr: {
      fill: '',
      stroke: ''
    }
  },
  defaultVariants: {
    buttonType: 'brand',
    disabled: false,
    spaceY: '2xl',
    spaceX: '3xl',
    radius: 'lg',
    gap: 'lg',
    size: 'lg'
  },
  compoundVariants: [
    // disabled
    {
      buttonType: 'brand',
      disabled: true,
      className:
        'text-inactive bg-button-inactive-brand hover:bg-button-inactive-brand focus:shadow-none cursor-default'
    },
    {
      buttonType: 'cta',
      disabled: true,
      className:
        'text-inactive bg-button-inactive-cta hover:bg-button-inactive-cta focus:shadow-none cursor-default'
    },
    {
      buttonType: 'basic',
      disabled: true,
      className:
        'text-inactive bg-button-inactive-basic hover:bg-button-inactive-basic focus:shadow-none cursor-default'
    },
    {
      isFullWidth: true,
      loading: true,
      className: 'justify-center'
    },

    // fullwidth
    {
      isFullWidth: true,
      loading: true,
      className: 'justify-center'
    }
  ]
});

export { button };
